import { render, staticRenderFns } from "./order-fields.vue?vue&type=template&id=230fef77&scoped=true"
import script from "./order-fields.vue?vue&type=script&lang=js"
export * from "./order-fields.vue?vue&type=script&lang=js"
import style0 from "./order-fields.vue?vue&type=style&index=0&id=230fef77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fef77",
  null
  
)

export default component.exports